import axios from './axios';

export const getBanner = () => axios.get('v1/banners/');

export const getBanners = () => axios.get('v1/banners/many');
